var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirefox = function SvgFirefox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__a)",
    d: "M21.391 8.551c-.44-1.064-1.334-2.213-2.034-2.576.5.97.846 2.012 1.027 3.088l.002.017c-1.146-2.868-3.09-4.026-4.677-6.545a12 12 0 0 1-.239-.39 3 3 0 0 1-.111-.21 1.9 1.9 0 0 1-.158-.42.03.03 0 0 0-.016-.009.04.04 0 0 0-.02 0l-.004.003-.008.004.004-.007c-2.546 1.497-3.41 4.268-3.489 5.655a5.06 5.06 0 0 0-2.79 1.08 3 3 0 0 0-.262-.2 4.74 4.74 0 0 1-.029-2.488 7.5 7.5 0 0 0-2.44 1.894h-.005c-.401-.511-.373-2.197-.35-2.55a2 2 0 0 0-.338.18 7.4 7.4 0 0 0-.991.853 9 9 0 0 0-.948 1.142v.001-.002a8.6 8.6 0 0 0-1.36 3.084l-.013.067c-.02.09-.088.538-.1.636l-.002.022a10 10 0 0 0-.165 1.403v.053c.004 2.547.96 5 2.677 6.875a10.108 10.108 0 0 0 13.652 1.168 10.2 10.2 0 0 0 3.797-6.322q.024-.196.046-.394a10.5 10.5 0 0 0-.657-5.113zM9.707 16.52c.048.023.092.047.14.069l.008.005zm10.68-7.437v-.01.011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__b)",
    d: "M21.39 8.551c-.44-1.064-1.333-2.213-2.033-2.576.5.97.846 2.012 1.027 3.088v.01l.002.01a9.25 9.25 0 0 1-.316 6.871c-1.162 2.504-3.973 5.07-8.375 4.943-4.755-.135-8.945-3.68-9.727-8.32-.142-.732 0-1.103.072-1.698a7.6 7.6 0 0 0-.163 1.405v.052c.005 2.547.96 5 2.677 6.875a10.108 10.108 0 0 0 13.652 1.168 10.2 10.2 0 0 0 3.797-6.322q.024-.195.046-.394a10.5 10.5 0 0 0-.657-5.113z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__c)",
    d: "M21.39 8.551c-.44-1.064-1.333-2.213-2.033-2.576.5.97.846 2.012 1.027 3.088v.01l.002.01a9.25 9.25 0 0 1-.316 6.871c-1.162 2.504-3.973 5.07-8.375 4.943-4.755-.135-8.945-3.68-9.727-8.32-.142-.732 0-1.103.072-1.698a7.6 7.6 0 0 0-.163 1.405v.052c.005 2.547.96 5 2.677 6.875a10.108 10.108 0 0 0 13.652 1.168 10.2 10.2 0 0 0 3.797-6.322q.024-.195.046-.394a10.5 10.5 0 0 0-.657-5.113z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__d)",
    d: "M16.463 9.747q.033.022.063.046a5.5 5.5 0 0 0-.941-1.233c-3.152-3.165-.826-6.86-.434-7.05l.004-.005c-2.546 1.497-3.41 4.268-3.49 5.655.12-.009.236-.019.357-.019a5.1 5.1 0 0 1 2.57.702 5.1 5.1 0 0 1 1.871 1.903"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__e)",
    d: "M12.027 10.38c-.016.252-.907 1.126-1.219 1.126-2.882 0-3.35 1.75-3.35 1.75.127 1.475 1.15 2.69 2.387 3.331q.085.044.172.082.149.066.297.122c.425.151.87.237 1.32.256 5.052.238 6.03-6.067 2.384-7.898.86-.112 1.731.1 2.444.596a5.1 5.1 0 0 0-1.87-1.903 5.1 5.1 0 0 0-2.57-.701c-.121 0-.239.01-.357.018a5.06 5.06 0 0 0-2.79 1.08c.154.13.328.306.696.67.688.68 2.452 1.385 2.456 1.468z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__f)",
    d: "M12.027 10.38c-.016.252-.907 1.126-1.219 1.126-2.882 0-3.35 1.75-3.35 1.75.127 1.475 1.15 2.69 2.387 3.331q.085.044.172.082.149.066.297.122c.425.151.87.237 1.32.256 5.052.238 6.03-6.067 2.384-7.898.86-.112 1.731.1 2.444.596a5.1 5.1 0 0 0-1.87-1.903 5.1 5.1 0 0 0-2.57-.701c-.121 0-.239.01-.357.018a5.06 5.06 0 0 0-2.79 1.08c.154.13.328.306.696.67.688.68 2.452 1.385 2.456 1.468z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__g)",
    d: "M8.402 7.902q.122.078.21.14a4.74 4.74 0 0 1-.029-2.488 7.5 7.5 0 0 0-2.44 1.893c.05-.001 1.52-.027 2.26.455"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__h)",
    d: "M1.967 12.578c.782 4.64 4.972 8.186 9.727 8.32 4.402.125 7.213-2.441 8.375-4.943a9.25 9.25 0 0 0 .315-6.87v-.01q-.002-.012 0-.01l.002.017c.36 2.358-.835 4.64-2.702 6.188l-.006.013c-3.638 2.976-7.12 1.795-7.823 1.313l-.147-.074c-2.121-1.018-2.998-2.957-2.81-4.622a2.6 2.6 0 0 1-2.4-1.517 3.81 3.81 0 0 1 3.727-.15c1.2.547 2.566.601 3.805.15-.004-.083-1.768-.788-2.456-1.468-.367-.364-.542-.539-.696-.67a3 3 0 0 0-.262-.2l-.21-.139c-.739-.483-2.209-.456-2.258-.455h-.004c-.402-.511-.374-2.197-.35-2.55a2 2 0 0 0-.34.18 7.4 7.4 0 0 0-.99.853 9 9 0 0 0-.952 1.14 8.6 8.6 0 0 0-1.36 3.082c-.005.021-.365 1.602-.187 2.422z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__i)",
    d: "M15.584 8.56c.37.364.688.78.942 1.234q.085.063.152.125c2.298 2.127 1.094 5.134 1.004 5.347 1.867-1.545 3.06-3.83 2.702-6.188-1.146-2.87-3.091-4.029-4.676-6.547a12 12 0 0 1-.24-.39 3 3 0 0 1-.11-.21 1.9 1.9 0 0 1-.159-.421.03.03 0 0 0-.016-.009.04.04 0 0 0-.02 0q0 .001-.004.003l-.007.004c-.393.187-2.718 3.885.434 7.047z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__j)",
    d: "M16.678 9.92a2 2 0 0 0-.152-.125l-.063-.047a3.5 3.5 0 0 0-2.445-.596c3.646 1.831 2.668 8.134-2.385 7.898a4.5 4.5 0 0 1-1.319-.256 5 5 0 0 1-.468-.204l.007.005c.704.483 4.185 1.663 7.823-1.314l.006-.013c.09-.213 1.295-3.22-1.005-5.347z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__k)",
    d: "M7.458 13.256s.468-1.751 3.35-1.751c.312 0 1.204-.874 1.22-1.127a5.03 5.03 0 0 1-3.806-.15 3.81 3.81 0 0 0-3.727.15 2.595 2.595 0 0 0 2.401 1.517c-.187 1.664.689 3.603 2.81 4.622.047.023.091.048.14.07-1.238-.643-2.26-1.857-2.388-3.33z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#firefox_svg__l)",
    d: "M21.39 8.551c-.44-1.064-1.333-2.213-2.033-2.576.5.97.846 2.012 1.027 3.088l.002.017c-1.146-2.868-3.09-4.026-4.677-6.545a12 12 0 0 1-.239-.39 3 3 0 0 1-.111-.21 2 2 0 0 1-.158-.42.03.03 0 0 0-.016-.009.04.04 0 0 0-.02 0l-.004.003-.008.004.004-.007c-2.546 1.497-3.41 4.268-3.489 5.655.118-.008.235-.018.356-.018a5.1 5.1 0 0 1 2.57.7 5.1 5.1 0 0 1 1.871 1.904 3.5 3.5 0 0 0-2.444-.596c3.646 1.83 2.668 8.134-2.385 7.898a4.5 4.5 0 0 1-1.319-.256 5 5 0 0 1-.298-.122q-.086-.039-.17-.082l.006.005-.147-.074q.07.035.14.069c-1.238-.642-2.26-1.857-2.387-3.33 0 0 .468-1.751 3.35-1.751.312 0 1.203-.873 1.22-1.127-.005-.082-1.769-.788-2.457-1.468-.367-.364-.542-.539-.696-.67a3 3 0 0 0-.262-.2 4.74 4.74 0 0 1-.028-2.487 7.5 7.5 0 0 0-2.44 1.893h-.005c-.402-.511-.374-2.197-.35-2.55a2 2 0 0 0-.339.18 7.4 7.4 0 0 0-.99.853 9 9 0 0 0-.948 1.142 8.6 8.6 0 0 0-1.36 3.083l-.014.067c-.02.09-.105.545-.117.642q-.117.706-.15 1.42v.052c.005 2.547.96 5 2.678 6.875a10.108 10.108 0 0 0 13.652 1.168 10.2 10.2 0 0 0 3.797-6.322q.024-.195.046-.394a10.5 10.5 0 0 0-.658-5.113"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.1334 0 0 21.2213 19.398 3.868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.1334 0 0 21.2213 11.551 12.535)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(15.3086 0 0 15.3723 14.167 -.859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.0619 0 0 10.1037 9.197 18.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.18626 -1.2591 1.47954 6.09425 12.573 10.714)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.23975 0 0 7.26986 11.29 3.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.8893 0 0 31.0177 17.044 -1.647)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(84.001 7.198 8.075)scale(22.7292 14.8565)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(19.2816 0 0 19.3618 11.29 5.707)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "firefox_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.1046 0 0 21.1924 16.26 6.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox_svg__a",
    x1: 20.049,
    x2: 3.153,
    y1: 4.758,
    y2: 20.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "firefox_svg__l",
    x1: 19.845,
    x2: 5.468,
    y1: 4.671,
    y2: 18.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
};
export default SvgFirefox;